import React, { useEffect, useState } from "react";

import { getProducts } from "../../services/firebase/firestore";

import AdminObraForm from "./AdminObraForm";


const AdminObras = () => {

    const [obras, setObras] = useState([]);

    const [obraEditando, setObraEditando] = useState(null);
    const [creandoObra, setCreandoObra] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [mensaje, setMensaje] = useState("");


    useEffect(() => {

        getProducts()
            .then(response => {

                const obrasOrdenadas = [...response].sort((a, b) =>
                    (a.nombre || "").localeCompare(b.nombre || "")
                );

                setObras(obrasOrdenadas);

            })
            .catch(error => {

                console.error(error);
                setError("No se pudieron cargar las obras.");

            })
            .finally(() => {

                setLoading(false);

            });

    }, []);


    const isEnabled = (value) => {
        return value === true || value === "si";
    };


    const ordenarObras = (items) => {

        return [...items].sort((a, b) =>
            (a.nombre || "").localeCompare(b.nombre || "")
        );

    };


    const handleAgregar = () => {

        setMensaje("");
        setObraEditando(null);
        setCreandoObra(true);

    };


    const handleEditar = (obra) => {

        setMensaje("");
        setCreandoObra(false);
        setObraEditando(obra);

    };


    const handleClose = () => {

        setCreandoObra(false);
        setObraEditando(null);

    };


    const handleSaved = (obraActualizada) => {

        setObras(prev => {

            const existe = prev.some(
                obra => obra.id === obraActualizada.id
            );

            const nuevasObras = existe
                ? prev.map(obra =>
                    obra.id === obraActualizada.id
                        ? obraActualizada
                        : obra
                )
                : [...prev, obraActualizada];

            return ordenarObras(nuevasObras);

        });


        if (creandoObra) {

            setCreandoObra(false);
            setObraEditando(null);
            setMensaje("Obra creada correctamente.");

        } else {

            setObraEditando(obraActualizada);

        }

    };


    const handleDeleted = (obraId) => {

        setObras(prev =>
            prev.filter(obra => obra.id !== obraId)
        );

        setObraEditando(null);
        setCreandoObra(false);

        setMensaje("Obra eliminada correctamente.");

    };


    if (loading) {

        return (
            <p>
                Cargando obras...
            </p>
        );

    }


    if (error) {

        return (
            <p className="admin-error">
                {error}
            </p>
        );

    }


    if (creandoObra) {

        return (
            <AdminObraForm
                onClose={handleClose}
                onSaved={handleSaved}
                onDeleted={handleDeleted}
            />
        );

    }


    if (obraEditando) {

        return (
            <AdminObraForm
                obra={obraEditando}
                onClose={handleClose}
                onSaved={handleSaved}
                onDeleted={handleDeleted}
            />
        );

    }


    return (
        <div className="admin-obras">

            <div className="admin-section-title">

                <h2>
                    Obras
                </h2>

                <div className="admin-section-actions">

                    <span>
                        {obras.length} obras
                    </span>

                    <button
                        type="button"
                        onClick={handleAgregar}
                    >
                        + Agregar obra
                    </button>

                </div>

            </div>


            {mensaje &&
                <p className="admin-success">
                    {mensaje}
                </p>
            }


            <div className="admin-obras-list">

                {obras.map(obra => (

                    <div
                        className="admin-obra-row"
                        key={obra.id}
                    >

                        <div
                            className="admin-obra-img"
                            style={{
                                backgroundImage:
                                    `url('/img/obras/${obra.id}.webp')`
                            }}
                        />


                        <div className="admin-obra-info">

                            <strong>
                                {obra.nombre || obra.id}
                            </strong>

                            <span>
                                {obra.categoria || "Sin categoría"}
                            </span>

                        </div>


                        <div className="admin-obra-status">

                            <span>
                                {isEnabled(obra.activo)
                                    ? "Activa"
                                    : "Inactiva"
                                }
                            </span>

                            {isEnabled(obra.home) &&
                                <span>
                                    Home
                                </span>
                            }

                        </div>


                        <button
                            type="button"
                            onClick={() => handleEditar(obra)}
                        >
                            Editar
                        </button>

                    </div>

                ))}

            </div>

        </div>
    );

};


export default AdminObras;